import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11a1b9cb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dashboard" }
const _hoisted_2 = { key: 2 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "p-mt-6" }, "Latest influencers", -1))
const _hoisted_4 = {
  key: 3,
  class: "p-d-flex p-flex-column p-flex-wrap"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "p-mt-2" }, "Latest campaigns", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Message = _resolveComponent("Message")!
  const _component_GenericPrompt = _resolveComponent("GenericPrompt")!
  const _component_modal_page = _resolveComponent("modal-page")!
  const _component_on_boarding_modal = _resolveComponent("on-boarding-modal")!
  const _component_header_dashboard = _resolveComponent("header-dashboard")!
  const _component_latest_influencers = _resolveComponent("latest-influencers")!
  const _component_set_your_profile = _resolveComponent("set-your-profile")!
  const _component_search_for_campaigns = _resolveComponent("search-for-campaigns")!
  const _component_latest_campaigns = _resolveComponent("latest-campaigns")!
  const _component_success_invite = _resolveComponent("success-invite")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.changeEmailOutcome.result !== 'pending')
      ? (_openBlock(), _createBlock(_component_Message, {
          key: 0,
          sticky: false,
          class: "messageContainer",
          severity: _ctx.changeEmailOutcome.result
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.changeEmailOutcome.message), 1)
          ]),
          _: 1
        }, 8, ["severity"]))
      : _createCommentVNode("", true),
    (_ctx.showChangeEmailPrompt)
      ? (_openBlock(), _createBlock(_component_GenericPrompt, {
          key: 1,
          version: "invalidEmail",
          containsInput: true,
          submitFunction: _ctx.updateEmail,
          useInputForSubmitFn: true
        }, null, 8, ["submitFunction"]))
      : _createCommentVNode("", true),
    _createVNode(_component_modal_page, { ref: "modalPage" }, null, 512),
    (_ctx.viewPerspective === _ctx.Perspective.BRAND)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_on_boarding_modal, {
            ref: "welcomeModalRef",
            show: _ctx.showOnBoardingModal,
            "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showOnBoardingModal) = $event))
          }, null, 8, ["show"]),
          _createVNode(_component_header_dashboard, {
            viewPerspective: _ctx.viewPerspective,
            user: _ctx.user,
            onSearch: _ctx.searchDashboard
          }, null, 8, ["viewPerspective", "user", "onSearch"]),
          _hoisted_3,
          _createVNode(_component_latest_influencers, {
            limit: _ctx.limitInfluences,
            items: _ctx.filteregInfluencers || _ctx.lastInfluences
          }, null, 8, ["limit", "items"])
        ]))
      : _createCommentVNode("", true),
    (
        _ctx.viewPerspective === _ctx.Perspective.CREATOR ||
        _ctx.viewPerspective === _ctx.Perspective.AGENCY
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_header_dashboard, {
            viewPerspective: _ctx.viewPerspective,
            user: _ctx.user,
            onSearch: _ctx.searchDashboard
          }, null, 8, ["viewPerspective", "user", "onSearch"]),
          _hoisted_5,
          _createVNode(_component_set_your_profile, {
            show: _ctx.showSetYourProfile,
            "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showSetYourProfile) = $event)),
            onShowCampSearch: _ctx.showSearch
          }, null, 8, ["show", "onShowCampSearch"]),
          _createVNode(_component_search_for_campaigns, {
            show: _ctx.showSearchForCampaigns,
            "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showSearchForCampaigns) = $event))
          }, null, 8, ["show"]),
          _createVNode(_component_latest_campaigns, {
            limit: _ctx.limitCampaigns,
            items: _ctx.filteredCampaigns || _ctx.lastCampaigns
          }, null, 8, ["limit", "items"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_success_invite, {
      "show-modal": _ctx.showSuccessModalInvite,
      "campaign-id": _ctx.inviteToCampaignId,
      campaign: _ctx.invitedCampaign
    }, null, 8, ["show-modal", "campaign-id", "campaign"])
  ]))
}